// How far before the newest loaded message a refresh starts looking. A message
// can reach the database a little after a later one, so the window overlaps
// and duplicates are dropped by id.
export const REFRESH_OVERLAP_SECONDS = 300

// A range counts as "live" when it reaches into the last day, so new
// messages could still land in it.
export const LIVE_RANGE_SLACK_MS = 24 * 3600 * 1000

export function isLiveRange(rangeTo: number | undefined, now: number = Date.now()): boolean {
  return rangeTo !== undefined && rangeTo >= now - LIVE_RANGE_SLACK_MS
}

interface IdentifiedMessage {
  MSG_RAW_ID: number
  SIGFOX_TIME: number
}

/**
 * Add freshly fetched messages to the loaded list: drop ones already loaded,
 * then put the rest at the newest end (top when newest-first, bottom when
 * oldest-first), keeping the list's order.
 */
export function mergeNewMessages<T extends IdentifiedMessage>(
  loaded: T[],
  incoming: T[],
  sortOrder: 'asc' | 'desc'
): { messages: T[]; added: T[] } {
  const known = new Set(loaded.map(m => m.MSG_RAW_ID))
  const added = incoming
    .filter(m => !known.has(m.MSG_RAW_ID))
    .sort((a, b) => (sortOrder === 'desc' ? b.SIGFOX_TIME - a.SIGFOX_TIME : a.SIGFOX_TIME - b.SIGFOX_TIME))
  if (added.length === 0) return { messages: loaded, added }
  return { messages: sortOrder === 'desc' ? [...added, ...loaded] : [...loaded, ...added], added }
}
